import { SET_ACCOUNT_LIST } from "../ActionName/ActionName";

const initialState = {
    accountList: [],
    timestamp: Date.now()
}

const AccountReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_ACCOUNT_LIST:
            return {
                ...state,
                accountList: action.value || [],
                timestamp: Date.now()
            }

        default:
            return state;
    }
}

export default AccountReducer;
